import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Fa from 'react-fontawesome';
import { Tab, Button } from 'react-bootstrap';
import { range, find, delay } from 'lodash';

import {
  fetchWinLossOpportunitySurveys, requestShowSurveyEmail,
  fetchWinLossAccountSurveys,
  winLossCancelSurveys,
  winLossRequestTogglePauseSurvey,
} from '../../../Dashboard/DashboardActions';
import { getWinLossOpportunitySurveys } from '../../../Dashboard/DashboardReducer';
import { getTVCollectorRefs } from '../../../Setup/SetupReducer';
import { getCanSetupOrganization } from '../../../Auth/AuthReducer';
import Shimmer from '../../../../components/shimmer';
import CancelOutreachForm from './CancelOutReachForm';
import { transalteLanguageCode, transalteLanguageCodes } from '../../../../util/helpers';
import RequestRow from './RequestRow';

import styles from './styles.css';

class RequestTab extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      cancellingItems: {
        // index by contact.id
      },
      currentCancelContact: null,
      showCancelModal: false,
    };
    this.requestAddSurvey = this.requestAddSurvey.bind(this);
    this.requestShowEmail = this.requestShowEmail.bind(this);
    this.handleRequestCancel = this.handleRequestCancel.bind(this);
    this.handleRequestTogglePause = this.handleRequestTogglePause.bind(this);
    this.handleModalClose = this.handleModalClose.bind(this);
    this.handleCancelOutreach = this.handleCancelOutreach.bind(this);
    this.requestChangeLanguage = this.requestChangeLanguage.bind(this);
  }

  componentDidMount() {
    this.mounted = true;
    this.checkProps(this.props);
  }

  componentWillReceiveProps(nextProps) {
    const { isActive } = nextProps;
    if (isActive && this.props.isActive !== isActive) {
      this.checkProps(nextProps);
    }
  }

  componentWillUnmount() {
    this.mounted = false;
  }

  requestShowEmail(data) {
    const { object, isAccount } = this.props;
    this.props.dispatch(requestShowSurveyEmail({ ...data, is_account: isAccount, account_id: object.account_id }));
  }

  handleModalClose(contact) {
    const { cancellingItems } = this.state;
    if (cancellingItems[contact.id]) {
      cancellingItems[contact.id].resolve(false);
      const newState = { ...cancellingItems };
      delete newState[contact.id];
      this.setState({ cancellingItems: newState, showCancelModal: false }, () => {
        this.setState({ currentCancelContact: null });
      });
    } else {
      this.setState({ showCancelModal: false }, () => {
        this.setState({ currentCancelContact: null });
      });
    }
  }

  handleCancelOutreach(contact, reason) {
    const { object, isAccount } = this.props;
    const contactId = contact.id;
    const collectorId = contact.collector_id;
    const id = isAccount ? object.account_id : object.opportunity_id;
    const p = this.props.dispatch(winLossCancelSurveys(collectorId, id, contactId, isAccount, reason));
    return p;
  }

  handleRequestCancel(contact, cb = () => {}) {
    const { object } = this.props;
    const ccb = () => {
      this.refreshTable();
      cb();
    };
    return this.props.requestCancelContact(contact, object, ccb);
  }

  requestChangeLanguage(survey) {
    const { collectors } = this.props;
    let collector = null;
    if (survey) {
      const clientId = survey.client_id;
      const programId = survey.program_id;
      const collectorId = survey.collector_id;
      if (collectors[clientId] && collectors[clientId][programId]) {
        collector = find(collectors[clientId][programId], { collector_id: collectorId });
        if (collector) {
          const availableLanguages = collector ? transalteLanguageCodes(collector.used_languages) : [];
          const currentLanguage = survey.language ? transalteLanguageCode(survey.language) : null;
          this.props.requestChangeLanguage(survey, currentLanguage, availableLanguages);
        }
      }
    }
  }

  handleRequestTogglePause(contact) {
    const { object, isAccount } = this.props;
    const contactId = contact.id;
    const collectorId = contact.collector_id;
    const id = isAccount ? object.account_id : object.opportunity_id;
    const status = contact.contact_status; // last_status or contact_status???
    let isPause = false;
    if (status === 'TERMINATED' || status === 'PAUSED') {
      isPause = false;
    } else {
      isPause = true;
    }
    const p = this.props.dispatch(winLossRequestTogglePauseSurvey(collectorId, id, contactId, isPause, isAccount));
    p.then(() => {
      this.refreshTable();
    })
    return p;
  }

  checkProps(props) {
    const {
      object, isAccount, surveys, totalRequests,
    } = props;
    const id = isAccount ? object.account_id : object.opportunity_id;
    if (!surveys && this.mounted && totalRequests > 0) {
      this.setState({ loading: true });
      const fetchAction = isAccount ? fetchWinLossAccountSurveys : fetchWinLossOpportunitySurveys;

      this.props.dispatch(fetchAction(id))
        .then(() => {
          if (this.mounted) {
            this.setState({ loading: false }, () => {
              this.refreshTable();
            });
          }
        });
    } else {
      this.setState({ loading: false }, () => {
        this.refreshTable();
      });
    }
  }

  refreshTable() {
    delay(() => {
      if (this.props.measure) {
        this.props.measure(); // reason: we pass data to redux, then refresh later 
      }
    }, 100);
  }

  requestAddSurvey() {
    this.props.requestAddSurvey(this.props.object);
  }

  renderSurveyItem(survey) {
    const { collectors } = this.props;

    let collector = null;
    if (survey) {
      const clientId = survey.client_id;
      const programId = survey.program_id;
      const collectorId = survey.collector_id;
      if (collectors[clientId] && collectors[clientId][programId]) {
        collector = find(collectors[clientId][programId], { collector_id: collectorId });
      }
    }

    const canChangeSenderEmail = this.props.canChangeSenderEmail && collector && collector.can_update_contact_sender;

    return (
      <RequestRow
        key={survey.id}
        survey={survey}
        requestShowEmail={this.requestShowEmail}
        requestChangeLanguage={this.requestChangeLanguage}
        requestChangeSenderEmail={this.props.requestChangeSenderEmail}
        requestShowOutreachPlan={this.props.requestShowOutreachPlan}
        requestCancelContact={this.handleRequestCancel}
        requestTogglePause={this.handleRequestTogglePause}
        canChangeSenderEmail={canChangeSenderEmail}
        object={this.props.object}
      />
    );
  }

  renderList() {
    const { surveys } = this.props;
    if (!surveys) {
      return null;
    }
    if (surveys.length === 0) {
      return this.renderEmpty();
    }
    const { currentCancelContact, showCancelModal } = this.state;

    return (
      <div>
        {surveys.map(survey => this.renderSurveyItem(survey))}
        {currentCancelContact !== null &&
          <CancelOutreachForm
            show={showCancelModal}
            contact={currentCancelContact}
            onClose={this.handleModalClose}
            onRequestCancel={this.handleCancelOutreach}
          />
        }
      </div>
    );
  }

  renderLoading() {
    const { totalRequests } = this.props;
    const items = range(totalRequests);

    return (
      <div>
        {items.map(item => (
          <div key={item} className="well well-sm">
            <div className="row">
              <div className="col-sm-3">
                <Shimmer value="XXX" full />
              </div>
              <div className="col-sm-7">
                <Shimmer value="XXX" full />
              </div>
            </div>
          </div>
        ))}
      </div>
    );
  }

  renderResults() {
    const { loading } = this.state;
    if (loading) {
      return this.renderLoading();
    }
    return this.renderList();
  }

  renderAddFeedbackButton() {
    const { showAddButton, feedbackRequestStatus } = this.props;
    if (!showAddButton) {
      return null;
    }
    if (feedbackRequestStatus !== {} && feedbackRequestStatus.loading) {
      return (
        <Button bsStyle="default" bsSize="xs"><Fa name="spinner" spin /></Button>
      );
    }
    return (
      <Button onClick={this.requestAddSurvey} bsStyle="default"><Fa name="plus" /> Ask for Feedback</Button>
    );
  }

  renderEmpty() {
    return (
      <div className="text-left">
        <div className="well well-sm">
          No feedback requests have been sent. {this.renderAddFeedbackButton()}
        </div>
      </div>
    );
  }

  render() {
    const {
      eventKey, title, totalRequests,
      className,
    } = this.props;
    return (
      <Tab
        eventKey={eventKey}
        title={title}
      >
        <div className={`${styles.section} ${className}`}>
          {totalRequests === 0 && this.renderEmpty()}
          {totalRequests > 0 && this.renderResults()}
        </div>
      </Tab>
    );
  }
}

function mapStateToProps(state, ownProps) {
  const id = ownProps.isAccount ? ownProps.object.account_id : ownProps.object.opportunity_id;
  const surveys = getWinLossOpportunitySurveys(state, id);
  return {
    surveys,
    canChangeSenderEmail: getCanSetupOrganization(state),
    collectors: getTVCollectorRefs(state),
  };
}

RequestTab.propTypes = {
  dispatch: PropTypes.func.isRequired,
  object: PropTypes.shape({
    opportunity_id: PropTypes.string,
    account_id: PropTypes.string,
  }).isRequired,
  eventKey: PropTypes.string.isRequired,
  title: PropTypes.oneOfType([
    PropTypes.node,
    PropTypes.string,
  ]).isRequired,
  totalRequests: PropTypes.number,
  requestAddSurvey: PropTypes.func,
  measure: PropTypes.func,
  surveys: PropTypes.arrayOf(PropTypes.shape({})),
  isActive: PropTypes.bool,
  isAccount: PropTypes.bool,
  requestShowOutreachPlan: PropTypes.func,
  surveyControlDropup: PropTypes.bool,
  canChangeSenderEmail: PropTypes.bool,
  requestChangeSenderEmail: PropTypes.func,
  requestChangeLanguage: PropTypes.func,
  requestCancelContact: PropTypes.func,
  className: PropTypes.string,
  showAddButton: PropTypes.bool,
  collectors: PropTypes.shape({}),
  feedbackRequestStatus: PropTypes.shape({}),
};

RequestTab.defaultProps = {
  surveys: null,
  totalRequests: 0,
  requestAddSurvey: () => {},
  measure: () => {},
  isActive: false,
  isAccount: false,
  requestShowOutreachPlan: () => Promise.reject(new Error('need handler')),
  surveyControlDropup: false,
  canChangeSenderEmail: false,
  requestChangeSenderEmail: () => {},
  requestChangeLanguage: () => {},
  requestCancelContact: () => {},
  className: null,
  showAddButton: true,
  collectors: null,
  feedbackRequestStatus: {},
};

export default connect(mapStateToProps)(RequestTab);
